import { render, staticRenderFns } from "./baseMsg.vue?vue&type=template&id=63a01a0f&scoped=true&"
import script from "./baseMsg.vue?vue&type=script&lang=js&"
export * from "./baseMsg.vue?vue&type=script&lang=js&"
import style0 from "./baseMsg.vue?vue&type=style&index=0&id=63a01a0f&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63a01a0f",
  null
  
)

export default component.exports